import React from 'react';

import styles from './FullViewMessage.module.css';

const Error = ({ children }) => <div className={styles.root}>{children}</div>;

export default Error;
